module.exports = __webpack_public_path__ + "stgallen.svg?170970bd0a9878079582f1ab0e6b3d89";